import { render } from "./AdminNotificationsBell.vue?vue&type=template&id=3140b33e&scoped=true"
import script from "./AdminNotificationsBell.vue?vue&type=script&lang=js"
export * from "./AdminNotificationsBell.vue?vue&type=script&lang=js"

import "./AdminNotificationsBell.vue?vue&type=style&index=0&id=3140b33e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3140b33e"]])

export default __exports__